module.exports = __webpack_public_path__ + "img/kompanija1.16c4d3fa.jpg";